import "./style.scss";

import Close from "@mui/icons-material/Close";
import Pen from "assets/img/svg/pen";
import StyledButton from "components/shared/StyledButton";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "store/store";

interface ILocationsManagement {
    onClose: () => void;
}

const LocationsManagement = ({ onClose }: ILocationsManagement) => {
    const [t] = useTranslation();
    const nav = useNavigate();

    const { locations } = useAppSelector((state) => state.stock);

    return (
        <div className="stock-locations-modal">
            <Close className="close-btn" onClick={onClose} />
            <div className="modal-title">
                <h3>{t("Stock.ModalTitle")}</h3>
                <p>{t("Stock.ModalSubtitle")}</p>
            </div>

            <div className="stock-names">
                {locations.map((location, i) => {
                    return (
                        <div className="name" key={i}>
                            <span>{location.name}</span>
                            <button onClick={() => nav("/settings/company")}>
                                <Pen />
                            </button>
                        </div>
                    );
                })}
            </div>

            <div className="stock-modal-btns">
                <StyledButton buttonType="outlined" onClick={() => nav("/settings/company")}>
                    {t("Stock.Modify")}
                </StyledButton>
                <StyledButton buttonType="primary" onClick={onClose}>
                    {t("Stock.Close")}
                </StyledButton>
            </div>
        </div>
    );
};

export default LocationsManagement;
